module.exports = {"id":"200395","name":"Marcelo Silva","rating":"71","photo":"./data/images/photos/3/200395.png","club":{"name":"Real Salt Lake","logo":"./data/images/clubs/RealSaltLake.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarceloSilva0.json
// module id = 2725
// module chunks = 0